import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Caption from './caption';
import LeftContent from './leftContent';
import RightContent from './rightContent';
import { getSeoAbDisplay } from '../../../../common/seoAbBucket';

class Content extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;
        const { captionData, leftContentData, rightContentData } = content;
        const { articleTitle } = getSeoAbDisplay({
            title: captionData.title,
            seoAbValue: captionData.seoAbValue,
            seoTitle: captionData.seoTitle,
            seoDescription: captionData.seoDescription,
            quanPlugin: captionData.quanPlugin,
        });

        return (
            <div className={styles.content}>
                <Caption content={{ ...captionData, title: articleTitle }} />
                <LeftContent content={leftContentData} />
                <RightContent content={rightContentData} />
                <div className="clear" />
            </div>
        );
    }
}

export default Content;
